// export default function BankDetails({
//   bankName,
//   companyName,
//   accountNo,
//   ifscCode,
//   branchAddress,
//   accountType,
//   qrCodeSrc,
//   upiId,
// }) {
//   return (
//     <div className="bg-white rounded-lg shadow-md md:p-8 mb-6 md:mb-8 flex flex-col md:flex-row gap-6 border border-[#E5E5E5]">
//       {/* Left Section: Bank Details and UPI ID */}
//       <div className="w-full md:w-2/3">
//         <table className="table-auto w-full text-sm md:text-base">
//           <tbody>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">Bank Name</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span className="flex items-center">{bankName}</span>
//               </td>
//             </tr>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">Company Name</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span>{companyName}</span>
//               </td>
//             </tr>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">Account No.</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span className="flex items-center">{accountNo}</span>
//               </td>
//             </tr>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">IFSC Code</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span className="flex items-center">{ifscCode}</span>
//               </td>
//             </tr>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">Branch Address</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span>{branchAddress}</span>
//               </td>
//             </tr>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">Account Type</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span>{accountType}</span>
//               </td>
//             </tr>
//             <tr>
//               <td className="py-2 align-top text-[#1D3557]">
//                 <span className="font-medium">UPI ID</span>
//               </td>
//               <td className="pl-3 text-[#1D3557]">
//                 <span className="flex flex-col md:flex-row">
//                   {upiId}
//                   <button
//                     onClick={() =>
//                       (window.location.href = `upi://pay?pa=${upiId}&pn=POSUser&cu=INR`)
//                     }
//                     className="max-w-[200px] md:ml-3 mt-4 md:mt-0 px-3 py-1 text-xs md:text-sm bg-[#FFD700] hover:bg-[#FFE55C] cursor-pointer text-[#1D3557] rounded font-semibold"
//                   >
//                     Pay Now
//                   </button>
//                 </span>
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       {/* Right Section: QR Code in Phone-like Container */}
//       <div className="w-full md:w-1/3 flex justify-center">
//         <div className="border border-[#E5E5E5] rounded-xl shadow-lg bg-gray-50 flex items-center justify-center w-full max-w-[280px] h-[440px] p-4">
//           <img
//             src={qrCodeSrc}
//             alt="QR Code"
//             width={220}
//             height={220}
//             style={{
//               width: "auto",
//               height: "auto",
//               maxWidth: "100%",
//               maxHeight: "100%",
//             }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }
import React from "react";
import { motion } from "framer-motion";

export default function BankDetails({
  bankName,
  companyName,
  accountNo,
  ifscCode,
  branchAddress,
  accountType,
  qrCodeSrc,
  upiId,
}) {
  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0, 1] },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  return (
    // <motion.div
    //   initial={{ opacity: 0, y: 20 }}
    //   whileInView={{ opacity: 1, y: 0 }}
    //   transition={{ duration: 0.8 }}
    //   viewport={{ once: true }}
    //   className="bg-white rounded-2xl shadow-xl p-6 md:p-8 mb-6 md:mb-8 flex flex-col md:flex-row gap-6 border border-gray-100 relative overflow-hidden"
    // >
    //   {/* Floating Elements */}
    //   <div className="absolute inset-0 pointer-events-none">
    //     <motion.div
    //       animate={{
    //         y: [0, -20, 0],
    //         x: [0, 10, 0],
    //       }}
    //       transition={{ duration: 15, repeat: Infinity }}
    //       className="absolute -top-10 -right-10 w-40 h-40 bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //     <motion.div
    //       animate={{
    //         y: [0, 20, 0],
    //         x: [0, -10, 0],
    //       }}
    //       transition={{ duration: 18, repeat: Infinity }}
    //       className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#105840]/5 rounded-full blur-3xl"
    //     />
    //   </div>

    //   {/* Top Wave */}
    //   <div className="absolute top-0 left-0 w-full pointer-events-none">
    //     <svg
    //       className="w-full h-16"
    //       viewBox="0 0 1440 100"
    //       preserveAspectRatio="none"
    //     >
    //       <motion.path
    //         animate={{
    //           d: [
    //             "M0,50 C300,70 600,30 900,50 C1200,70 1440,30 1440,50 L1440,0 L0,0 Z",
    //             "M0,60 C300,40 600,80 900,60 C1200,40 1440,80 1440,60 L1440,0 L0,0 Z",
    //             "M0,50 C300,70 600,30 900,50 C1200,70 1440,30 1440,50 L1440,0 L0,0 Z",
    //           ],
    //         }}
    //         transition={{ duration: 8, repeat: Infinity }}
    //         fill="#105840"
    //         fillOpacity="0.03"
    //       />
    //     </svg>
    //   </div>

    //   {/* Left Section: Bank Details and UPI ID */}
    //   <motion.div
    //     variants={staggerContainer}
    //     initial="hidden"
    //     whileInView="visible"
    //     viewport={{ once: true }}
    //     className="w-full md:w-2/3 relative z-10"
    //   >
    //     {/* Green Line Above Heading */}
    //     <div className="flex items-center gap-3 mb-6">
    //       <motion.div
    //         initial={{ width: 0 }}
    //         whileInView={{ width: "40px" }}
    //         transition={{ duration: 0.8 }}
    //         className="h-1 mt-1 bg-[#105840] rounded-full"
    //       />
    //       <span className="text-xs font-medium text-[#105840] mt-1 tracking-wider">
    //         BANK DETAILS
    //       </span>
    //     </div>

    //     <table className="table-auto w-full text-sm md:text-base">
    //       <tbody>
    //         {[
    //           { label: "Bank Name", value: bankName },
    //           { label: "Company Name", value: companyName },
    //           { label: "Account No.", value: accountNo },
    //           { label: "IFSC Code", value: ifscCode },
    //           { label: "Branch Address", value: branchAddress },
    //           { label: "Account Type", value: accountType },
    //         ].map((item, index) => (
    //           <motion.tr
    //             key={index}
    //             variants={fadeInUp}
    //             className="border-b border-gray-100 last:border-0"
    //           >
    //             <td className="py-3 align-top text-gray-600 font-medium w-1/3">
    //               {item.label}
    //             </td>
    //             <td className="pl-4 text-gray-900">
    //               <span className="flex items-center">{item.value}</span>
    //             </td>
    //           </motion.tr>
    //         ))}

    //         {/* UPI ID Row with Button */}
    //         <motion.tr variants={fadeInUp}>
    //           <td className="py-3 align-top text-gray-600 font-medium w-1/3">
    //             UPI ID
    //           </td>
    //           <td className="pl-4 text-gray-900">
    //             <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
    //               <span className="font-mono text-[#105840] font-medium">
    //                 {upiId}
    //               </span>
    //               <motion.button
    //                 whileHover={{ scale: 1.02, y: -1 }}
    //                 whileTap={{ scale: 0.98 }}
    //                 onClick={() =>
    //                   (window.location.href = `upi://pay?pa=${upiId}&pn=POSUser&cu=INR`)
    //                 }
    //                 className="px-4 py-2 text-sm bg-[#105840] hover:bg-[#0A4A30] text-white rounded-lg font-semibold transition-all shadow-md hover:shadow-lg"
    //               >
    //                 Pay Now
    //               </motion.button>
    //             </div>
    //           </td>
    //         </motion.tr>
    //       </tbody>
    //     </table>
    //   </motion.div>

    //   {/* Right Section: QR Code - Kept Exactly as Original */}
    //   <div className="w-full md:w-1/3 flex justify-center items-center relative z-10">
    //     <div className="border border-[#E5E5E5] rounded-xl shadow-lg bg-gray-50 flex items-center justify-center w-full max-w-[280px] h-[400px] p-4">
    //       <img
    //         src={qrCodeSrc}
    //         alt="QR Code"
    //         width={220}
    //         height={220}
    //         style={{
    //           width: "auto",
    //           height: "auto",
    //           maxWidth: "100%",
    //           maxHeight: "100%",
    //         }}
    //       />
    //     </div>
    //   </div>

    //   {/* Bottom Wave */}
    //   <div className="absolute bottom-0 left-0 w-full pointer-events-none">
    //     <svg
    //       className="w-full h-12"
    //       viewBox="0 0 1440 80"
    //       preserveAspectRatio="none"
    //     >
    //       <motion.path
    //         animate={{
    //           d: [
    //             "M0,40 C300,60 600,20 900,40 C1200,60 1440,20 1440,40 L1440,80 L0,80 Z",
    //             "M0,50 C300,30 600,70 900,50 C1200,30 1440,70 1440,50 L1440,80 L0,80 Z",
    //             "M0,40 C300,60 600,20 900,40 C1200,60 1440,20 1440,40 L1440,80 L0,80 Z",
    //           ],
    //         }}
    //         transition={{ duration: 8, repeat: Infinity }}
    //         fill="#105840"
    //         fillOpacity="0.03"
    //       />
    //     </svg>
    //   </div>

    //   <style jsx>{`
    //     @keyframes pulse {
    //       0%,
    //       100% {
    //         opacity: 0.5;
    //         transform: scale(1);
    //       }
    //       50% {
    //         opacity: 0.8;
    //         transform: scale(1.05);
    //       }
    //     }
    //     .animate-pulse {
    //       animation: pulse 2s ease-in-out infinite;
    //     }
    //   `}</style>
    // </motion.div>
    <div
      className="bg-[#1A2F3A] rounded-2xl shadow-xl p-6 md:p-8 mb-6 md:mb-8 flex flex-col md:flex-row gap-6 border border-[#2D5F7A]/30 relative overflow-hidden"
    >
      {/* Static Background Elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#2D5F7A]/20 rounded-full blur-3xl" />
        <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#7BC4E0]/10 rounded-full blur-3xl" />
      </div>

      {/* Left Section: Bank Details and UPI ID */}
      <div className="w-full md:w-2/3 relative z-10">
        {/* Blue Line Above Heading */}
        <div className="flex items-center gap-3 mb-6">
          <div className="w-[40px] h-1 bg-[#7BC4E0] rounded-full" />
          <span className="text-xs font-medium text-[#7BC4E0] tracking-wider">
            BANK DETAILS
          </span>
        </div>

        <table className="table-auto w-full text-sm md:text-base">
          <tbody>
            {[
              { label: "Bank Name", value: bankName },
              { label: "Company Name", value: companyName },
              { label: "Account No.", value: accountNo },
              { label: "IFSC Code", value: ifscCode },
              { label: "Branch Address", value: branchAddress },
              { label: "Account Type", value: accountType },
            ].map((item, index) => (
              <tr
                key={index}
                className="border-b border-[#2D5F7A]/20 last:border-0"
              >
                <td className="py-3 align-top text-[#8FAFC7] font-medium w-1/3">
                  {item.label}
                </td>
                <td className="pl-4 text-white">
                  <span className="flex items-center">{item.value}</span>
                </td>
              </tr>
            ))}

            {/* UPI ID Row with Button */}
            <tr>
              <td className="py-3 align-top text-[#8FAFC7] font-medium w-1/3">
                UPI ID
              </td>
              <td className="pl-4 text-white">
                <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
                  <span className="font-mono text-[#7BC4E0] font-medium">
                    {upiId}
                  </span>
                  <button
                    onClick={() =>
                      (window.location.href = `upi://pay?ver=01&mode=01&orgid=180071&pa=additri@idfcbank&pn=ADDITRI SWAYAM SEVA MICRO CREDIT ASSOCIATION&mc=5734&mid=MID85709969161&mtid=TID85709969161A&qrMedium=04`)
                    }
                    className="px-4 py-2 text-sm bg-[#2D5F7A] hover:bg-[#1E3B4A] text-white rounded-lg font-semibold transition-colors shadow-md"
                  >
                    Pay Now
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Right Section: QR Code */}
      <div className="w-full md:w-1/3 flex justify-center items-center relative z-10">
        <div className="border border-[#2D5F7A]/30 rounded-xl shadow-lg bg-[#0F2128] flex items-center justify-center w-full max-w-[280px] h-[400px] p-4">
          <img
            src={qrCodeSrc}
            alt="QR Code"
            width={220}
            height={220}
            style={{
              width: "auto",
              height: "auto",
              maxWidth: "100%",
              maxHeight: "100%",
            }}
          />
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }
        .animate-pulse {
          animation: pulse 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
